export { ServicesLinksStrategy } from './ServiceLinks'
export { ServicesDataResourcesStrategy } from './DataResource'
export { ServicesStrategy } from './Services'
export { DetailedServiceStrategy } from './DetailedService'
export { DeviationsStrategy } from './Deviations'
export { ResourceDeviationsStrategy } from './ResourceDeviations'
export { DeviatedServicesStrategy } from './DeviatedServices'
